<!-- Contact Us -->
<oth-hero [contents]="appHeroContent"></oth-hero>
<div class="contact-us-page-content">
  <oth-card [bodyTemplate]="bodyTemplate">
    <ng-template #bodyTemplate>
      <div class="body">
        <div *ngIf="emailSent">
          <label i18n="@@contactUs.completed">Thank you for reaching us. Our team will contact with you soon.</label>
        </div>
        <form (ngSubmit)="onSubmit()" *ngIf="!emailSent" [formGroup]="form">
          <div [class.error-input]="submitted && form.controls.firstName.invalid" class="input-with-label">
            <input formControlName="firstName" placeholder="Jane" required type="text" />
            <h4 i18n="@@contactUs.firstName">First Name</h4>
          </div>
          <div [class.error-input]="submitted && form.controls.secondName.invalid" class="input-with-label">
            <input formControlName="secondName" placeholder="Doe" required type="text" />
            <h4 i18n="@@contactUs.lastLane">Last Name</h4>
          </div>
          <div [class.error-input]="submitted && form.controls.workEmail.invalid" class="input-with-label">
            <input formControlName="workEmail" placeholder="jane.doe@example.com" required type="text" />
            <h4 i18n="@@contactUs.email">Email</h4>
          </div>
          <div [class.error-input]="submitted && form.controls.workPhone.invalid" class="input-with-label">
            <input formControlName="workPhone" placeholder="9848416722" type="text" required maxlength="10" />
            <h4 i18n="@@contactUs.phoneNumber">Phone Number</h4>
          </div>
          <!-- <div
              [class.error-input]="submitted && form.controls.companyWebsite.invalid"
              class="input-with-label">
            <input
                formControlName="companyWebsite"
                placeholder="example.com"
                type="text"
            />
            <h4 i18n="@@contactUs.website">Website</h4>
          </div> -->
          <!-- <div [class.error-input]="submitted && form.controls.companySize.invalid" class="input-with-label">
            <select (change)="changeCompanySize($event)" formControlName="companySize">
              <option class="default-option" disabled i18n="@@contactUs.rangeOfEmployees" value="">
                Select range of employees
              </option>
              <option *ngFor="let option of sizeOptions" [ngValue]="option">
                {{ option }}
              </option>
            </select>
            <h4 i18n="@@contactUs.companySize">Company Size</h4>
          </div> -->
          <!-- <div [class.error-input]="submitted && form.controls.country.invalid" class="input-with-label">
            <select (change)="changeCountry($event)" formControlName="country">
              <option class="default-option" disabled i18n="@@contactUs.selectCountry" value="">Select a country
              </option>
              <option *ngFor="let country of countries" [ngValue]="country">
                {{ country }}
              </option>
            </select>
            <h4 i18n="@@contactUs.country">Country</h4>
          </div> -->
          <div [class.error-input]="submitted && form.controls.state.invalid" class="input-with-label">
            <select (change)="changeState($event)" formControlName="state">
              <option class="default-option" disabled i18n="@@contactUs.selectState" value="">Select a state
              </option>
              <option *ngFor="let state of states" [ngValue]="state">
                {{ state }}
              </option>
            </select>
            <h4 i18n="@@contactUs.state">State</h4>
          </div>
          <div [class.error-input]="submitted && form.controls.anythingElse.invalid" class="input-with-label">
            <textarea formControlName="anythingElse" i18n-placeholder="@@contactUs.yourMessage.placeholder"
              maxlength="500" placeholder="Tell us more about your project, needs, and timeline...."
              rows="5"></textarea>
            <h4 i18n="@@contactUs.yourMessage">Your Message</h4>
          </div>
          <div class="button-area">
            <oth-button [icon]="'envelope'" i18n-text="@@contactUs.contactUsButton" text="CONTACT US">
            </oth-button>
          </div>
        </form>
      </div>
    </ng-template>
  </oth-card>
  <div *ngIf="features" class="features-area">
    <h3 class="header">{{ features.title }}</h3>
    <div *ngFor="let feature of features.features">
      <i [class]="'fas fa-check fa-fw'" aria-hidden="true"></i>
      <h4>{{ feature }}</h4>
    </div>
  </div>
</div>
<div class="footer">
  <div class="footer-card-wrapper">
    <i aria-hidden="true" class="fa fa-comments fa-fw"></i>
    <div class="footer-card-left-column">
      <h4 i18n="@@contactUs.generalCommunication.header">SR GROUP – Powering Industry with Trust, Quality & Expertise
      </h4>
      <h4>To get in touch with us, please complete the enquiry form
        <!-- <a [href]="'mailto: ' + environmentCommon.company.email" class="theme-color-link">
          {{ environmentCommon.company.email }}
        </a> -->
      </h4>
    </div>
  </div>

  <div class="footer-download">
    <h5>While we get back to you based on your enquiry, you may also checkout a brief about all our product range
    </h5>
    <a href="assets/docs/flyer.pdf" target="_blank" rel="noopener noreferrer" class="download-link">
      📄 Download Flyer
    </a>
  </div>
</div>